import React, { useEffect, useState } from 'react';

import WF from 'utils/waveform';
import { sleep } from 'utils';
import Block from './Block';
import Metronome from './Metronome';

import { Footer } from './styles';

let wf = null;
const Waveform = React.memo(
  ({
    options,
    player,
    setDecodeing,
    setFileSize,
    setChannelNum,
    setRender,
  }) => {
    const $waveform = React.createRef();

    useEffect(() => {
      if (wf) wf.destroy();

      wf = new WF({
        container: $waveform.current,
        mediaElement: player.template.$video,
        backgroundColor: 'rgb(20, 23, 38)',
        waveColor: 'rgba(255, 255, 255, 0.1)',
        progressColor: 'rgba(255, 255, 255, 0.5)',
        gridColor: 'rgba(255, 255, 255, 0.05)',
        rulerColor: 'rgba(255, 255, 255, 0.5)',
      });

      wf.on('render', setRender);
      wf.on('decodeing', setDecodeing);
      wf.on('fileSize', setFileSize);
      wf.on('audiobuffer', audiobuffer =>
        setChannelNum(audiobuffer.numberOfChannels),
      );
      sleep(1000).then(() => wf.load(options.videoUrl));
    }, [
      player,
      $waveform,
      options.videoUrl,
      setDecodeing,
      setFileSize,
      setChannelNum,
      setRender,
    ]);
    return <div className="waveform" ref={$waveform} />;
  },
  (prevProps, nextProps) =>
    prevProps.options.videoUrl === nextProps.options.videoUrl,
);

export default function(props) {
  const [decodeing, setDecodeing] = useState(0);
  const [fileSize, setFileSize] = useState(0);
  const [channelNum, setChannelNum] = useState(1);
  const [metronome, setMetronome] = useState(false);
  const [render, setRender] = useState({
    padding: 5,
    duration: 10,
    gridNum: 110,
    beginTime: 0,
  });

  return (
    <Footer>
      <div className="timeline-header">
        <div className="timeline-header-left">
          <div className="item">
            <div className="name">
              <p>Áudio Waveform:</p>
            </div>
            <div className="value">
              <input
                type="checkbox"
                defaultChecked
                onChange={event => {
                  if (!wf) return;
                  wf.setOptions({
                    wave: event.target.checked,
                  });
                }}
              />
            </div>
          </div>
          <div className="item">
            <div className="name">
              <p>tamanho-arquivo:</p>
            </div>
            <div className="value" style={{ color: '#FF5722' }}>
              {((fileSize || 0) / 1024 / 1024).toFixed(2)} M
            </div>
          </div>
          <div className="item">
            <div className="name">
              <p>decodificação-audio</p>
            </div>
            <div className="value" style={{ color: '#FF5722' }}>
              {((decodeing || 0) * 100).toFixed(2)}%
            </div>
          </div>
          <div className="item">
            <div className="name">
              <p>Canal de renderização</p>
            </div>
            <div className="value">
              <select
                defaultValue={0}
                onChange={event => {
                  if (!wf) return;
                  wf.changeChannel(Number(event.target.value || 0));
                }}
              >
                {Array(channelNum)
                  .fill()
                  .map((_, index) => (
                    <option key={index} value={index}>
                      {index + 1}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="item">
            <div className="name">
              <p>timeline-zoom</p>
            </div>
            <div className="value">
              <input
                defaultValue="30"
                type="range"
                min="5"
                max="100"
                step="1"
                onChange={event => {
                  if (!wf) return;
                  wf.setOptions({
                    duration: Number(event.target.value || 30),
                  });
                }}
              />
            </div>
          </div>
          <div className="item">
            <div className="name">
              <p>waveform-zoom</p>
            </div>
            <div className="value">
              <input
                defaultValue="2"
                type="range"
                min="0.1"
                max="4"
                step="0.1"
                onChange={event => {
                  if (!wf) return;
                  wf.setOptions({
                    waveScale: Number(event.target.value || 2),
                  });
                }}
              />
            </div>
          </div>
          <div className="item">
            <div className="name">
              <p>space-metronome</p>
            </div>
            <div className="value">
              {metronome ? (
                <span style={{ color: '#4CAF50' }}>ON</span>
              ) : (
                <span style={{ color: '#FF5722' }}>OFF</span>
              )}
            </div>
          </div>
          <div className="item">
            <div
              style={{ cursor: 'pointer' }}
              className="value"
              onClick={() => {
                if (!wf) return;
                wf.exportImage();
              }}
            >
              <p>Exportar Imagem</p>
            </div>
          </div>
        </div>
      </div>
      <div className="timeline-body">
        {props.player ? (
          <Waveform
            {...props}
            setDecodeing={setDecodeing}
            setFileSize={setFileSize}
            setChannelNum={setChannelNum}
            setRender={setRender}
          />
        ) : null}
        <Metronome
          {...props}
          render={render}
          metronome={metronome}
          setMetronome={setMetronome}
        />
        <Block {...props} render={render} />
      </div>
    </Footer>
  );
}
